"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@cian/system-logger/shared");
exports.formatMessageLog = function (level, message, meta) {
    return {
        message: message,
        level: level,
        meta: shared_1.convertMetaToKeyValue(meta),
    };
};
//# sourceMappingURL=formatMessageLog.js.map